module.exports = __webpack_public_path__ + "static/img/10016 (4).c2e5995.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10016 (4).webp
// module id = 638/
// module chunks = 14